import React, { Component } from 'react';
import './Usage.css';

//import DoDont from './DoDont.js';

export class SectionSmall extends Component {
    render() {
        return (
            <div className="DoDont-grid-s">

                {this.props.data.map(({ key, color, title, description, imgSrc }) => {
                    return (
                        <div
                            className="DoDont-s"
                            key={key}>
                            <div className="DoDont-Img-Container">
                                <img
                                    className="DoDont-Img"
                                    alt="" src={imgSrc}></img>
                            </div>
                            <div
                                className="DoDont-Info"
                                style={{ borderTopColor: color }}>
                                <span
                                    className="DoDont-Title"
                                    style={{ color: color }}>
                                    {title}
                                </span>
                                <span className="DoDont-Description">
                                    {description}
                                </span>
                            </div>
                        </div>
                    )
                })}

            </div>
        )
    }
};

export class SectionBig extends Component {
    render() {
        return (
            <div className="DoDont-grid-l">

                {this.props.data.map(({ key, color, title, description, imgSrc }) => {
                    return (
                        <div
                            className="DoDont-l"
                            key={key}>
                            <div className="DoDont-Img-Container">
                                <img
                                    className="DoDont-Img"
                                    alt="" src={imgSrc}></img>
                            </div>
                            <div
                                className="DoDont-Info"
                                style={{ borderTopColor: color }}>
                                <span
                                    className="DoDont-Title"
                                    style={{ color: color }}>
                                    {title}
                                </span>
                                <span className="DoDont-Description">
                                    {description}
                                </span>
                            </div>
                        </div>
                    )
                })}

            </div>
        );
    }
};